import Model from 'flarum/common/Model';
export default class DiscussionBan extends Model {
  reason = (() => Model.attribute('reason'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  revokedAt = (() => Model.attribute('revokedAt', Model.transformDate))();
  user = (() => Model.hasOne('user'))();
  bannedBy = (() => Model.hasOne('bannedBy'))();
  revokedBy = (() => Model.hasOne('revokedBy'))();
  discussion = (() => Model.hasOne('discussion'))();
}
flarum.reg.add('huseyinfiliz-discussion-ban', 'common/models/DiscussionBan', DiscussionBan);